import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getHotlist(callId: string | number) {
  const data = await apiGet(`hotlist/${callId}`);
  usePortcallStore().setHotlist(data);
  return data;
}
